import Vue from "vue";
import "./forms";
import "./tables";
import "./notifications";

Vue.component("MainLayout", require("@/app/layouts/main").default);
Vue.component("KeyValue", require("./KeyValue").default);
Vue.component("TabFilters", require("./TabFilters").default);
Vue.component("ExpandableCard", require("./expandableCard").default);
